import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    MdHome, MdPrecisionManufacturing, MdBuild
} from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import SidebarModule from './SidebarModule';
import './Sidebar.css';

const sidebarModules = [
    {
        title: "Blogs",
        icon: MdPrecisionManufacturing,
        links: [
            { to: "/blogs", label: "Blogs", icon: MdPrecisionManufacturing },
            { to: "/create-blog", label: "Create Blog", icon: MdBuild }
        ],
    },
];


const Sidebar = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { pathname } = useLocation();

    const isActive = (link) => {
        if (link.match === "startsWith") {
            return pathname.startsWith(link.to);
        }
        return pathname === link.to;
    };

    return (
        <div className={`sidebar bg-light ${isCollapsed ? "collapsed" : ""}`}>
            <div className="sidebar-header">
                <button
                    className="toggle-btn"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    <GiHamburgerMenu />
                </button>
                {!isCollapsed && <h1 className="sidebar-title">Dashboard</h1>}
            </div>

            <nav>
                {/* Home */}
                <Link to="/" className={pathname === "/" ? "active" : ""}>
                    <MdHome />
                    {!isCollapsed && <span>Homepage</span>}
                </Link>

                {/* Modules */}
                {sidebarModules.map((module) => (
                    <SidebarModule
                        key={module.title}
                        title={module.title}
                        icon={module.icon}
                        isCollapsed={isCollapsed}
                    >
                        {module.links.map((link) => (
                            <Link
                                key={link.to}
                                to={link.to}
                                className={isActive(link) ? "active" : ""}
                            >
                                <link.icon />
                                {!isCollapsed && <span>{link.label}</span>}
                            </Link>
                        ))}
                    </SidebarModule>
                ))}
            </nav>
        </div>
    );
};

export default Sidebar;
